import React from 'react';
import Filter from './Filter';

const Header = () => {
  return <Filter />;
};

export default Header;
